// extracted by mini-css-extract-plugin
export var activeDot = "_62-c";
export var buttonContainer = "_62-9";
export var channelButton = "_62-a";
export var content = "_62-0";
export var contentFull = "_62-2";
export var contentThird = "_62-1";
export var contentWrapper = "_62-7";
export var description = "_62-5";
export var heightShort = "_62-e";
export var image = "_62-3";
export var imageContainer = "_62-4";
export var selectButton = "_62-d";
export var spinnerContainer = "_62-b";
export var titleContent = "_62-8";
export var titleWrapper = "_62-6";